/* eslint-disable @typescript-eslint/no-explicit-any */
import { 
    AxiosRequestHeaders, 
    AxiosResponse, 
    InternalAxiosRequestConfig 
} from "axios";
import Notify from 'quasar/src/plugins/Notify.js';;
import router from "@/router";
import store from "@/store";

interface CustomAxiosRequestHeaders extends AxiosRequestHeaders {
    'Authorization': string;
    'x-auth-user': string;
    'x-auth-role': string;
    'x-current-locale': string;
}

export function interceptRequest(request: InternalAxiosRequestConfig<any>) {
    request.headers = {
        'Authorization': 'Bearer ' + store.state.accessTokenKey,
        'x-auth-user': store.state.userCode || '',
        'x-auth-role': store.state.roleCode || '',
        'x-current-locale': store.state.locale || 'th'
    } as CustomAxiosRequestHeaders
    return request
}

export function interceptRequestError(error: InternalAxiosRequestConfig<any>) {
    return Promise.reject(error)
}

export function interceptResponse(response: AxiosResponse<any, any>) {
    const responseType = response.config.responseType
    if (responseType === 'blob') {
        // download file
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        const filename = response.headers['content-disposition']
        .split(';')
        .find((s: string | string[]) => s.includes('filename'))
        .split('=')[1]
        .replace(/"/g, '')
        link.href = url
        link.setAttribute('download', decodeURIComponent(filename))
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
    }
    return response
}

export function interceptResponseError(error: any) {
    const errorCode = error.code;
    const responseMsg = error.response.data.message;
    const status = error.response.status;
    if (status == 401) {
        Notify.create({
            type: 'negative',
            message: 'ERROR ' + errorCode,
            caption: responseMsg,
            position: 'top-right',
            timeout: 5000
        })
    } else {
        if (['INVALID_REFRESH_TOKEN','REFRESH_TOKEN_EXPIRED'].indexOf(responseMsg) > -1) {
            router.push('/login')
        } else {
            Notify.create({
                type: 'negative',
                message: 'ERROR ' + status,
                caption: responseMsg,
                position: 'top-right',
                timeout: 5000
            })
        } 
    }
    return
}